// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorShippingProfiles = (client) => ({
    /**
     * `POST /vendor/shipping-profiles`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateShippingProfile
     * @source packages/modules/b2c-core/src/api/vendor/shipping-profiles/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/shipping-profiles", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/shipping-profiles/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteShippingProfileById
     * @source packages/modules/b2c-core/src/api/vendor/shipping-profiles/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/shipping-profiles/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/shipping-profiles`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListShippingProfiles
     * @source packages/modules/b2c-core/src/api/vendor/shipping-profiles/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/shipping-profiles", { method: "GET", query, headers }),
    /**
     * `GET /vendor/shipping-profiles/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetShippingProfile
     * @source packages/modules/b2c-core/src/api/vendor/shipping-profiles/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/shipping-profiles/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/shipping-profiles/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateShippingProfile
     * @source packages/modules/b2c-core/src/api/vendor/shipping-profiles/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/shipping-profiles/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=shipping-profiles.js.map